/**
 *  ==========================
 *  BLOCK: Icon Block
 *  ==========================
 */

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import {
    disabledBlocks,
    i18n,
    pluginAssetsURL,
    srcUrl
} from 'cartzillagb'
import DefaultImage  from  './img/img1.png'

/**
 * Internal dependencies
 */
import edit from './edit'
import save from './save'
import { HeaderIcon } from '~cartzillagb/icons'
import { createButtonAttributes } from '~cartzillagb/util'

export const schema = {
    hideLeftbanner: {
        type: 'boolean',
        default: true,
    },
    hideRightbanner: {
        type: 'boolean',
        default: true,
    },
    banner1Pretitle: {
        type: 'string'
    },
    banner1Title: {
        type: 'string'
    },
    banner2Title: {
        type: 'string'
    },
    banner2Desc: {
        type: 'string'
    },
    mediaURL: {
        type: 'string',
        default: `${ srcUrl }/${ DefaultImage }`
    },
    backgroundImageURL: {
        type: 'string',
        default: `${ pluginAssetsURL }img/390x226/img1.jpg`,
    },
    backgroundColor: {
        type: 'string',
    },
    background: {
        type: 'string',
        default: 'bg-primary',
    },
    enableButton1: {
        type: 'boolean',
        default: true,
    },
    enableButton2: {
        type: 'boolean',
        default: true,
    },
    bgcolor: {
        type: 'string',
        default: 'bg-secondary'
    },
    custombgcolor: {
        type: 'string',
    },
    enableImage: {
        type: 'boolean',
        default: true,
    },
    enableContainer: {
        type: 'boolean',
        default: true,
    },
    containerClass: {
        type: 'string',
        default: 'pb-4 mb-md-3',
    },
    ...createButtonAttributes( 'button1%s', {
        defaultText: 'Shop Now',
        isShadow: true,
        defaultSize: 'sm'
    } ),
    ...createButtonAttributes( 'button2%s', {
        defaultText: 'Contact us',
        isShadow: true,
        defaultSize: 'sm'
    } ),
}

export const name = 'czgb/banner'

export const settings = {
    title: __( 'Banner', i18n ),
    description: __( 'Capture the attention of your audience with Banners that calls to an action.', i18n ),
    icon: HeaderIcon,
    category: 'cartzillagb',
    example: {},
    keywords: [
        __( 'Banner', i18n ),
        __( 'CartzillaGB', i18n ),
    ],
    attributes: schema,
    supports: {
        inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
    },

    edit,
    save,

    // CartzillaGB modules.
    modules: {
        'advanced-responsive': true,
    },
}
